{
    "DirectoryList_Column_Description": "Description",
    "DirectoryList_Column_TelephoneNumber": "Numéro de téléphone",
    "DirectoryList_Add_Disabled_SelectTelSys": "Sélectionnez un serveur de téléphonie pour ajouter une entrée d'annuaire.",
    "DirectoryList_Add_Disabled_NoTelephonyFilter": "Désactivez le filtre « pas de serveur de téléphonie » pour ajouter une entrée d'annuaire.",
    "NAME": "RépertoireLangue"
}